import pendoService from './pendoService';

export const getPendoServicePromise = () =>
  new Promise((res) => {
    const isInstalled = pendoService.isInstalled();
    if (isInstalled) {
      res();
      return;
    }
    const checkingInitializedInterval = setInterval(() => {
      if (pendoService.isInstalled()) {
        clearInterval(checkingInitializedInterval);
        res();
      }
    }, 200);
  }).then(() => {
    if (!pendoService.isStarted()) {
      pendoService.start();
    }
  });
